import { Route, Routes } from 'react-router-dom'
import NotFound from 'routes/NotFound'
import Page from 'components/global/Page'
import { useApp } from 'store/steps'
import { useDeleteCartMutation } from 'store/api-slice/hooks'
import { useAppDispatch } from 'store/hooks'
import FullPageLoader from 'components/global/FullPageLoader'
import ServerErrorModal from 'components/global/ServerErrorModal'
import { setIsErrorModalOpened } from 'store/general-slice'
import { selfcareFirstStep } from 'routes/basenames'
import ConfirmationModal from 'components/global/ConfirmationModal'
import { DEFAULT_LANG } from 'constants/i18n'
import { SelfcareLogin } from 'routes/selfcare/SelfcareLogin'
import { SelfcareProtectedRoute } from 'routes/selfcare/SelfcareProtectedRoute'
import { SelfcareDataWrapper } from 'routes/selfcare/SelfcareDataWrapper'
import { useSelfcareAuth } from 'routes/selfcare/auth/useSelfcareAuth'
import { useSelfcareRoutes } from 'routes/selfcare/utils/useSelfcareRoutes'

const Selfcare = () => {
    const dispatch = useAppDispatch()
    const { getPath, language } = useApp()
    const { isLoading, isAuthenticated } = useSelfcareAuth()
    const selfcareRoutes = useSelfcareRoutes()

    const [deleteCart] = useDeleteCartMutation()

    const handleAcceptError = () => {
        deleteCart({
            _locale: language ?? DEFAULT_LANG,
            cartCreatorType: 'standard',
        }).then(() => {
            dispatch(setIsErrorModalOpened(false))
            window.location.replace(selfcareFirstStep)
        })
    }

    if (isLoading) return <FullPageLoader />

    return (
        <Page isFullWidth={!isAuthenticated}>
            <Routes>
                <Route
                    path={getPath('selfcare_login')}
                    element={<SelfcareLogin />}
                />
                <Route path="*" element={<NotFound />} />

                <Route element={<SelfcareProtectedRoute />}>
                    <Route element={<SelfcareDataWrapper />}>
                        {selfcareRoutes}
                    </Route>
                </Route>
            </Routes>
            <ServerErrorModal onClick={handleAcceptError} />
            <ConfirmationModal />
        </Page>
    )
}

export default Selfcare
